import React, { useRef } from 'react';
import { Layout } from 'antd';
const { Footer } = Layout;
import { Translate } from 'app/services';
import { ACTIVE_BRAND_CONFIG, IS_SEIKO_THEME } from '../../branding';
import './styles.less';
import { getTranslatedString } from '../../services/translationService/components/Translate';
import { TermsAndConditions } from '../termsAndConditions';
import { Link } from '../common';

export const AppFooter = ( ) => {

    const tnc = useRef( null );

    return (
        <Footer>
            <a href={ `mailto:${ ACTIVE_BRAND_CONFIG.metadata.contactEmail }` }>
                <Translate.Text value="footer.contactUs" />
            </a>
            <span onClick={ () => window.open( getTranslatedString( 'privacyNotice.link' ), '_newtab' ) }>
                <Translate.Text value="footer.privacyNotice" />
            </span>
            <span onClick={ () => window.open( '/documents/2020_Policy_Privacy_Shield_enUS.pdf', '_newtab' ) }>
                <Translate.Text value="footer.privacyShieldPolicy" />
            </span>
            <Link push to='/cookie-policy'>
                <Translate.Text  value="footer.cookiePolicy" />
            </Link>
            { !IS_SEIKO_THEME &&
                <span onClick={ () => tnc?.current.openTerms() }>
                    <TermsAndConditions cancellable ref={ tnc } termsFilter={ t => t.type == 'BUNCHBALL_ANON_USER' } />
                    <Translate.Text value="gamification.term" />
                </span>
            }
        </Footer>
    );
};